/**
 * 取消しの窓（見積書・請求書・領収書・{order}で共用。#188、Figma 173:118。{order}は #233 §13.7 ハ）。
 *   ・題に警告のしるし（朱の丸に「!」）＋1文だけ：「見積書「Q-0005」を取消して下書きへ戻します。」（2回目からの見積は「2回目「Q-0005-2」を…」）
 *   ・本文の箇条書きは無くした。説明は題の右の「？」
 *   ・ボタンは「閉じる」「下書きに戻す」（#138 の仕上げ：主の動きが取消しなので、脇は「取消」でなく「閉じる」）
 * 文は contract の UNISSUE_DIALOG_MSG 1か所
 */
import { UNISSUE_DIALOG_MSG, type UnissueDoc } from "@genbaryoku/contract";
import { t } from "../labels.js";
import { ErrorText, Help } from "./ui.jsx";

export function UnissueDialog({ doc, no, round, busy, error, onClose, onConfirm }: {
  doc: UnissueDoc;
  /** 取り消す番号（2回目からの見積は枝番つき） */
  no: string;
  /** 見積の回（2回目からは題を「n回目「番号」」にする） */
  round?: number;
  busy: boolean;
  error?: string | undefined;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const M = UNISSUE_DIALOG_MSG;
  // 帳票の名前は会社の言葉（{order}＝注文書／発注書…）を埋める
  const docName = t(M.doc[doc]);
  const title = round != null && round >= 2 ? M.roundTitle.replace("{round}", String(round)).replace("{no}", no) : M.title.replace("{doc}", docName).replace("{no}", no);
  const close = () => !busy && onClose();
  return (
    <div className="dim" onClick={(e) => e.target === e.currentTarget && close()}>
      <div className="dlg unissue" role="dialog" aria-label={M.name} data-testid="unissue-dialog" onKeyDown={(e) => e.key === "Escape" && close()}>
        <div className="dh">
          <span className="warnmark" role="img" aria-label={M.warn}>!</span>
          <span className="dht" data-testid="unissue-title">{title}</span>
          <Help testId="help-unissue" label={M.helpLabel} text={M.help.replace("{doc}", docName)} />
        </div>
        {error ? (
          <div className="db">
            <ErrorText>{error}</ErrorText>
          </div>
        ) : null}
        <div className="df">
          <button type="button" className="btn quiet" autoFocus disabled={busy} onClick={onClose}>{M.close}</button>
          <button type="button" className="btn shu" disabled={busy} onClick={onConfirm}>{M.confirm}</button>
        </div>
      </div>
    </div>
  );
}
